import styled from 'styled-components';
import { BaseContainer, SectionContainer } from '../../../styles/Container';
import media from '../../../styles/media';

export const Wrapper = styled.div`
  /* max-width: 1200px;
  margin-left: auto;
  margin-right: auto; */
`;

export const BannerStyle = {
  mobileHeight: '100vh',
  mediumHeight: '500px',
  desktopHeight: '500px',
};

export const Content = styled(BaseContainer)`
  padding-bottom: 60px;
  flex-direction: column;
  > div {
    display: flex;
    flex-wrap: wrap;
  }
  > section:last-of-type {
    margin-bottom: 40px;
  }
`;

export const Service = styled.section`
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  ${media('medium')} {
    flex-direction: row;
    /* Elementos impares, inverte ordem para alternar posição da imagem */
    :nth-of-type(2n) {
      flex-direction: row-reverse;
      /* Margin do div de texto, muda pra margin-left quando impar */
      > div:first-child {
        ${media('medium')} {
          margin-right: 0;
          margin-left: 26px;
        }
      }
    }
  }
  & + & {
    margin-top: 30px;
  }
  /* Div com markdown */
  > div:first-child {
    flex: 1;
    h2,
    h3 {
      ${media('medium', true)} {
        margin-top: 18px;
      }
      margin: 0;
      margin-bottom: 8px;
    }
    ${media('medium')} {
      margin-right: 26px;
    }
    p,
    ul,
    li,
    ol {
      font-weight: 400;
      a,
      strong {
        font-weight: 400;
      }
      a {
        text-decoration: underline;
      }
    }
  }
  /* Div da <Img /> */
  > div:nth-child(2) {
    /* Somente viewports menor que medium */
    ${media('medium', true)} {
      max-width: 350px;
      width: 100%;
      margin: auto;
      /* Controla altura da imagem através da largura */
    }
    /* Maior que medium */
    ${media('medium')} {
      width: 45%;
    }
  }
`;

export const TechnologyList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  h2 {
    color: ${(props) => props.theme.colors.darkText};
    margin-top: 0;
    font-size: 45px;
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 50px;
  }
  h1 {
    text-align: center;
    color: ${(props) => props.theme.colors.white};
    margin: 0;
    text-transform: capitalize;
    font-weight: 600;
    font-size: 34px;
    line-height: 1.2em;
    ${media('medium', 'large')} {
      font-size: 45px;
    }
    ${media('large')} {
      font-size: 55px;
    }
  }
`;

export const AsideImage = styled.div`
  width: 100%;
  > * {
    width: 100%;
  }
`;

export const WrapperImage = styled.div`
  width: 300px;
  > * {
    width: 100%;
  }
`;

export const TechContainer = styled(SectionContainer)`
  display: block;
  /* Mobile */
  padding: 50px 0;
  /* Medium and up */
  ${media('medium')} {
    padding: 80px 0;
  }
  /* Desktop and up */
  ${media('extraLarger')} {
    padding: 120px 0;
  }
  h3 {
    font-weight: 400;
  }
`;

export const BannerContainer = styled.section`
  width: 100%;
  position: relative;
  height: 250px;
  overflow: hidden;
  background: #20c3ff;
  > div {
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    text-align: center;
    height: 100%;
    color: #ffffff;
    object-fit: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    :nth-of-type(2) {
      position: absolute;
    }
  }
  h1 {
    font-size: 25px;
    line-height: 1.2em;
    ${media('medium', 'large')} {
      font-size: 40px;
    }
    ${media('large')} {
      font-size: 50px;
    }
  }
  ${media('medium', 'large')} {
    height: 300px;
  }
  ${media('large')} {
    height: 400px;
  }
`;

export const CallToAction = styled.button`
  margin: 20px auto;
  display: block;
  box-sizing: border-box;
  outline: 0;
  width: fit-content;
  padding: 20px 20px;
  font-size: 1em;
  text-transform: uppercase;
  color: #20c3ff;
  ${media('medium')} {
    padding: 20px 40px;
    font-size: 1.2em;
  }
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  background: #ffffff;
  border: none;
  text-decoration: none;
`;
